"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A global view into the error results on the client side
 */
var testResultsCache_1 = require("../server/workers/tested/common/testResultsCache");
exports.testResultsCache = new testResultsCache_1.TestResultsCache();



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/clientTestResultsCache.js
 ** module id = 59
 ** module chunks = 0
 **/